var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48828 2.83334H12.3958C14.1562 2.83334 15.5833 4.26043 15.5833 6.02084V9.095C15.5833 10.8554 14.1562 12.2825 12.3958 12.2825H6.48828C4.72787 12.2825 3.30078 10.8554 3.30078 9.095V6.02084C3.30078 4.26043 4.72787 2.83334 6.48828 2.83334ZM12.3958 10.1575C12.9794 10.1499 13.4507 9.67862 13.4583 9.095V6.02084C13.4507 5.43722 12.9794 4.96597 12.3958 4.95834H6.48828C5.90467 4.96597 5.43341 5.43722 5.42578 6.02084V9.095C5.43341 9.67862 5.90467 10.1499 6.48828 10.1575H12.3958Z",
    fill: "#3B72FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5533 2.83334H27.5116C29.272 2.83334 30.6991 4.26043 30.6991 6.02084V15.6967C30.6991 17.4571 29.272 18.8842 27.5116 18.8842H22.5533C21.7067 18.888 20.8938 18.5533 20.2952 17.9548C19.6966 17.3562 19.362 16.5432 19.3658 15.6967V6.02084C19.3658 4.26043 20.7928 2.83334 22.5533 2.83334ZM27.5116 16.7592C28.0984 16.7592 28.5741 16.2835 28.5741 15.6967V6.02084C28.5665 5.43722 28.0952 4.96597 27.5116 4.95834H22.5533C21.9665 4.95834 21.4908 5.43403 21.4908 6.02084V15.6967C21.4869 15.9796 21.5976 16.2521 21.7977 16.4522C21.9978 16.6523 22.2703 16.763 22.5533 16.7592H27.5116Z",
    fill: "#3B72FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5532 22.6667H27.5116C29.272 22.6667 30.6991 24.0938 30.6991 25.8542V27.9792C30.6991 29.7396 29.272 31.1667 27.5116 31.1667H22.5532C20.7928 31.1667 19.3657 29.7396 19.3657 27.9792V25.8542C19.3657 24.0938 20.7928 22.6667 22.5532 22.6667ZM27.5116 29.0417C28.0952 29.034 28.5664 28.5628 28.5741 27.9792V25.8542C28.5664 25.2706 28.0952 24.7993 27.5116 24.7917H22.5532C21.9664 24.7917 21.4907 25.2674 21.4907 25.8542V27.9792C21.4907 28.566 21.9664 29.0417 22.5532 29.0417H27.5116Z",
    fill: "#3B72FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48828 16.0508H12.3958C14.1562 16.0508 15.5833 17.4779 15.5833 19.2383V27.9792C15.5833 29.7396 14.1562 31.1667 12.3958 31.1667H6.48828C4.72787 31.1667 3.30078 29.7396 3.30078 27.9792V19.2383C3.30078 17.4779 4.72787 16.0508 6.48828 16.0508ZM12.3958 29.0417C12.9794 29.034 13.4507 28.5628 13.4583 27.9792V19.2383C13.4507 18.6547 12.9794 18.1835 12.3958 18.1758H6.48828C5.90467 18.1835 5.43341 18.6547 5.42578 19.2383V27.9792C5.43341 28.5628 5.90467 29.034 6.48828 29.0417H12.3958Z",
    fill: "#3B72FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f40bfb378e5c95ec8a2a4057ad8f4f7c.svg";
export { ForwardRef as ReactComponent };